import printConfig from '../print-config.json'


const getPrintAllFormatsSubKey = (printFormat, landscape)  => {
    const landscapeBoolean = landscape === "true" 
    const currentPrintFormat = _.findWhere(printConfig.formats, {path: printFormat, landscape: landscapeBoolean})
    const currentPrintID = _.findKey(printConfig.formats, currentPrintFormat)

    return currentPrintID
}

export default getPrintAllFormatsSubKey